import * as React from 'react';

import { cn } from '../../lib/utils';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  height?: string;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, height, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          'flex w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-inset focus-visible:ring-ring disabled:cursor-not-allowed disabled:border-muted-foreground/50 disabled:text-muted-foreground disabled:opacity-100 disabled:placeholder:text-foreground/50 disabled:placeholder:opacity-100 dark:disabled:border-border dark:disabled:bg-muted/30 dark:disabled:placeholder:text-foreground/45',
          className
        )}
        ref={ref}
        style={height ? { height } : {}}
        {...props}
      />
    );
  }
);
Textarea.displayName = 'Textarea';

export { Textarea };
